var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSidebarBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 15v1.25h8V15zM6 12.75V14h6v-1.25z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 17.75c0 .69-.56 1.25-1.25 1.25H4.25C3.56 19 3 18.44 3 17.75V2.25C3 1.56 3.56 1 4.25 1h11.5c.69 0 1.25.56 1.25 1.25zm-1.25-15.5V10H4.25V2.25zm0 15.5v-6.5H4.25v6.5z",
  clipRule: "evenodd"
})));
export default SvgSidebarBottom;